



























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import CardComponent from './Card/Card.vue';
import { Card } from '../store/cards/CardInterface';
import { cardList } from '../store/cards/cards';
import { CardListState } from '../store/cards/types';

// config for this instance of the store
const namespace = 'cardList';

/**
 * Initilizes the cardList store and renders the cards
 */
@Component({ components: { CardComponent } })
export default class CardListComponent extends Vue {
    // 🤮 ... try out this: https://dev.to/sirtimbly/type-safe-vuex-state-usage-in-components-without-decorators-2b24
    @Action('loadCards', { namespace }) loadCards: any;
    @Action('addCard', { namespace }) addCard: any;
    @Getter('totalCards', { namespace }) totalCards!: number;
    @Getter('list', { namespace }) list!: Card[];

    mounted() {
        this.loadCards();
    }
}
